import React from 'react';
import { color, Stack } from '@starrez/starryui9';
import { FlagIcon } from '@starrez/starryui';
import { ICellRenderer } from '../types';

interface IFlagColumnProps extends ICellRenderer<string> {
    showFlag: (data: any) => boolean;
}

export const FlagColumn = ({ data, showFlag = () => false }: IFlagColumnProps) => {
    return showFlag(data) ? (
        <div style={{ height: '100%', color: color.Red.R60 }}>
            <Stack height="100%">
                <FlagIcon />
            </Stack>
        </div>
    ) : (
        <></>
    );
};

export function useFlagColumn<TRowDate>(showFlag: (data: TRowDate) => boolean) {
    return {
        colId: 'flag-col',
        cellRendererFramework: FlagColumn,
        cellRendererParams: {
            showFlag,
        },
    };
}
